import * as React from "react";
const SvgFiRrGraphCurve = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-graph-curve_svg__a)">
      <path
        fill="#062147"
        d="M24 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V1a1 1 0 1 1 2 0v16.451C4.581 10.313 11.904 5 20 5h1.001l-2.218-2.277a1 1 0 1 1 1.433-1.394l3.207 3.293c.373.372.561.862.572 1.357 0 .008.004.014.004.022l-.002.008a2 2 0 0 1-.584 1.431l-3.25 3.25a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.275-2.275h-1.025c-8.433 0-15.937 6.396-16.887 14.313a2.97 2.97 0 0 0 1.887.687h18a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-graph-curve_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGraphCurve;
